/* Arctic Goddess — Footer (language selector popover) */

(function () {
  var ROOT_SELECTOR = '[data-footer-language]';
  var COOKIE = 'lang_preference_set';
  var COOKIE_MAX_AGE = 31536000; /* 365 days */

  function getToggle(root) {
    return root.querySelector('.footer__language-toggle');
  }

  function getList(root) {
    return root.querySelector('.footer__language-list');
  }

  function setOpen(root, open) {
    var toggle = getToggle(root);
    var list = getList(root);
    if (!toggle || !list) return;

    list.hidden = !open;
    root.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function init(root) {
    if (root.dataset.languageReady === 'true') return;

    var toggle = getToggle(root);
    var list = getList(root);
    if (!toggle || !list) return;

    root.dataset.languageReady = 'true';

    toggle.addEventListener('click', function (event) {
      event.stopPropagation();
      setOpen(root, list.hidden);
    });

    list.addEventListener('click', function (event) {
      var link = event.target.closest('.footer__language-option');
      if (!link) return;

      /* Never navigate the Theme Editor away, and never write cookies inside it. */
      if (window.Shopify && window.Shopify.designMode) {
        event.preventDefault();
        return;
      }

      /* The link's href does the navigating; this only records the preference.
         The head script's Rule 2 re-syncs it if this write is ever missed. */
      document.cookie =
        COOKIE +
        '=' +
        encodeURIComponent(link.getAttribute('data-locale')) +
        '; max-age=' +
        COOKIE_MAX_AGE +
        '; path=/; SameSite=Lax';
    });
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll(ROOT_SELECTOR), init);
  }

  /* Document-level listeners bind once, and read the live DOM, so Theme Editor
     section re-renders never leave stale closures behind. */
  if (!window.agFooterLanguageBound) {
    window.agFooterLanguageBound = true;

    document.addEventListener('click', function (event) {
      Array.prototype.forEach.call(document.querySelectorAll(ROOT_SELECTOR), function (root) {
        if (!root.contains(event.target)) setOpen(root, false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      Array.prototype.forEach.call(document.querySelectorAll(ROOT_SELECTOR), function (root) {
        var list = getList(root);
        var toggle = getToggle(root);
        if (list && !list.hidden) {
          setOpen(root, false);
          if (toggle) toggle.focus();
        }
      });
    });

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }
})();
